import { render, staticRenderFns } from "./HomeMasterTaxAttorney.vue?vue&type=template&id=911795c2&scoped=true&"
import script from "./HomeMasterTaxAttorney.vue?vue&type=script&lang=js&"
export * from "./HomeMasterTaxAttorney.vue?vue&type=script&lang=js&"
import style0 from "./HomeMasterTaxAttorney.vue?vue&type=style&index=0&id=911795c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911795c2",
  null
  
)

export default component.exports